import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  ACCESS_TOKEN_SET,
  SESSION_KEY_SET,
} from "constants/ActionTypes";

import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";

import axiosDBRoot from 'util/ApiDBRoot'

import { message } from "antd";

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

/*
// (Depreciated - Laravel Passport)
export const userSignIn = ({username, password}) => {
  return (dispatch) => {
    //dispatch({type: FETCH_START});

    axiosDBRoot.post('oauth/token', {
      'grant_type': 'password',
      'client_id': process.env.REACT_APP_AUTH_CLIENT_ID,
      'client_secret': process.env.REACT_APP_AUTH_CLIENT_SECRET,
      'username': username,
      'password': password,
      'scope': '*'
    }).then(({data}) => {
      //dispatch({ type: FETCH_SUCCESS });
      
      dispatch({type: SIGNIN_USER_SUCCESS, payload: {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        expires_in: data.expires_in
      }})
      
      localStorage.setItem("access_token", JSON.stringify(data.access_token));
      localStorage.setItem("refresh_token", JSON.stringify(data.refresh_token));

      dispatch(getUser());

    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: "Authentication failed."});
    })
  }
}
*/

// Cognito User Pool
export const userSignInAws = (data) => {
  return (dispatch) => {
   
    if(data.accessToken) {
      dispatch({type: SIGNIN_USER_SUCCESS, payload: {
        access_token: data.accessToken.jwtToken,
        refresh_token: data.refreshToken.token,
        expires_in: data.accessToken.payload.exp
      }})
      
      localStorage.setItem("access_token", JSON.stringify(data.accessToken.jwtToken));
      localStorage.setItem("refresh_token", JSON.stringify(data.refreshToken.token));
      localStorage.setItem("expires_in", JSON.stringify(data.accessToken.payload.exp));

      dispatch(getUser());
    }
   
  }
}

export const refreshToken = () => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START});

    const {refresh_token} = getState().auth;
    
    if(refresh_token) {
      axiosDBRoot.post('oauth/token', {
        'grant_type': 'refresh_token',
        'client_id': process.env.REACT_APP_AUTH_CLIENT_ID,
        'client_secret': process.env.REACT_APP_AUTH_CLIENT_SECRET,
        'refresh_token': refresh_token,
        'scope': '*'
      }).then(({data}) => {
        dispatch({ type: FETCH_SUCCESS });
    
        dispatch({type: SIGNIN_USER_SUCCESS, payload: {
          access_token: data.access_token,
          refresh_token: data.refresh_token,
          expires_in: data.expires_in
        }})
        
        localStorage.setItem("access_token", JSON.stringify(data.access_token));
        localStorage.setItem("refresh_token", JSON.stringify(data.refresh_token));

        //window.location.reload()
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
      })
    } else {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      //dispatch({ type: FETCH_SUCCESS });;
      dispatch({type: SIGNOUT_USER_SUCCESS});
    }
    
    
  }
}

export const userSignOut = () => {
  return (dispatch, getState) => {
    // const requestDBRoot = setupAxiosInterceptors(axiosDBRoot, dispatch, getState);

    // requestDBRoot.post('api/user/logout', {}).then(() => {
    //   localStorage.removeItem("access_token");
    //   localStorage.removeItem("refresh_token");
    //   //dispatch({ type: FETCH_SUCCESS });;
    //   dispatch({type: SIGNOUT_USER_SUCCESS});
    // }).catch(function (error) {
    //   dispatch({type: FETCH_ERROR, payload: error.message});
    // });
    localStorage.removeItem("expires_in");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("limesurvey_session_key");

    // Attempt to get session key
    dispatch(surveyUserSignIn());

    dispatch({type: SIGNOUT_USER_SUCCESS});
  }
};

export const getUser = () => {
  return (dispatch, getState) => {
    // Make another call to get user details such as:
    // - username (display name)
    // - permissions (used for UI control over item visibility)


    const {access_token} = getState().auth;

    if(access_token) {

      const requestDBRoot = setupAxiosInterceptors(axiosDBRoot, dispatch, getState);

      requestDBRoot.post('api/user', {}).then(({data}) => {
        dispatch({
          type: ACCESS_TOKEN_SET,
          payload: {
            userid: data.user.id,
            username: data.user.name,
            email: data.user.email,
            permissions: data.permissions,
            mode: data.mode,
            organisation: data.organisation
          }
        })

      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
      })
    }
    
  }
}

export const surveyUserSignIn = () => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START});

    /**
     * Get SESSION_KEY from Limesurvey
     * SESSION_KEY is mandatory for making further API calls to Limesurvey
     */
    const requestDBRoot = setupAxiosInterceptors(axiosDBRoot, dispatch, getState);

    return requestDBRoot.post('/ls/get-session-key').then(({ data }) => {
      localStorage.setItem("limesurvey_session_key", JSON.stringify(data));
        
      dispatch({type: SESSION_KEY_SET, payload: {
        session_key: data
      }});
      
      dispatch({ type: FETCH_SUCCESS });
    }).catch(function (error) {
      if(error.response.data.message) {
        dispatch({ type: FETCH_ERROR, payload: error.response.data.message });
      } else {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      }
    });

    /*
    return axios.post('admin/remotecontrol', {
        method: 'get_session_key',
        params: [process.env.REACT_APP_SURVEY_USERNAME, process.env.REACT_APP_SURVEY_PASSWORD],
        id: 1
      },
      axiosConfig
    ).then(({data}) => {
      //console.log(data.result);
      if (data.result) {
        localStorage.setItem("limesurvey_session_key", JSON.stringify(data.result));
        
        dispatch({type: SESSION_KEY_SET, payload: {
          session_key: data.result,
        }});

        dispatch({ type: FETCH_SUCCESS });
        
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
    */
  }
};

export const ActionSingUp = (formData) => {
  return (dispatch, getState) => {
    const requestDBRoot = setupAxiosInterceptors(axiosDBRoot, dispatch, getState);

      dispatch({type: FETCH_START});

      requestDBRoot.post('api/signup1', {
        formData: formData
      }).then(({data}) => {
        
        if(data.response.result === 'recaptcha error'){
          message.error('recaptcha error')
        } else if(data.response.error){
          message.error(data.response.error)
        }else{
          message.success('send successful')
        }

        dispatch({ type: FETCH_SUCCESS });
        
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
      })
    }
    
  
}